"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _collections = _interopRequireWildcard(require("./collections"));

var _debtwireNavigationLinks = _interopRequireDefault(require("./debtwireNavigationLinks"));

var _entitledToViewHomePage = _interopRequireDefault(require("./entitledToViewHomePage"));

var _productOrEditionHomepageUrl = require("./productOrEditionHomepageUrl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function editionsForIdArray(ids) {
  return ids.map(function (id) {
    return _collections.EDITIONS_ARRAY.find(function (edition) {
      return edition.id === id;
    });
  });
}

function editionsForFullId(ids) {
  return ids.map(function (id) {
    return _collections.EDITIONS_ARRAY.find(function (edition) {
      return edition.fullId === id;
    });
  });
}

function getMatchingEditions(match) {
  return _collections.EDITIONS_ARRAY.filter(function (edition) {
    return Object.keys(match).every(function (key) {
      return match[key] === edition[key];
    });
  });
}

module.exports = Object.assign({}, _collections["default"], {
  editionsForIdArray: editionsForIdArray,
  editionsForFullId: editionsForFullId,
  getMatchingEditions: getMatchingEditions,
  entitledToViewHomePage: _entitledToViewHomePage["default"],
  debtwireNavigationLinks: _debtwireNavigationLinks["default"],
  isEntitledOnlyToAbsMuniPrimaryIssuanceOrXtract: _collections.isEntitledOnlyToAbsMuniPrimaryIssuanceOrXtract,
  productOrEditionHomepageUrls: _productOrEditionHomepageUrl.productOrEditionHomepageUrls
});